import chef from '../assets/gro.png';
import G from '../assets/G.png';

import gallery01 from '../assets/gallery01.png';
import gallery02 from '../assets/gallery02.png';
import gallery03 from '../assets/gallery03.png';
import gallery04 from '../assets/gallery04.png';
import gallery05 from '../assets/gallery05.png';
import gallery06 from '../assets/gallery06.png';
import gallery07 from '../assets/gallery07.png';
import gallery08 from '../assets/gallery08.jpg';
import gallery09 from '../assets/gallery09.jpg';
import knife from '../assets/knife.png';
import spoon from '../assets/spoon.svg';
import sign from '../assets/signn.png';
import quote from '../assets/quote.png';
import gericht from '../assets/footz.png';


export default {
  G,
  chef,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  gallery06,
  gallery07,
  gallery08,
  gallery09,
  knife,
  spoon,
  sign,
  quote,
  gericht,
 
};
